module.exports = __webpack_public_path__ + "img/un-checked-white.ae3dabd5.svg";